import '../styles/index.scss';
import $ from "jquery";
import '/node_modules/jquery/dist/jquery.js';
import '/node_modules/jquery-validation/dist/jquery.validate.min.js';


let PUMALP = {
    init: function(){
        PUMALP.form();
        PUMALP.filterInput();
        //PUMALP.resize();
    },
    resize: function(){
        PUMALP.foldHeight();
        $(window).resize(function(){
            PUMALP.foldHeight();
        });
    },
    foldHeight: function(){
        if ( $('.js-puma-lp-wrapper').length > 0 && $(window).width() > 1024 ) {
            $('.js-puma-lp-wrapper').outerHeight($(window).height());
        } else {
            $('.js-puma-lp-wrapper').outerHeight('auto');
        }
    },
    form: function(){
        
        $('.js-puma-lp-form').validate({
            rules: {
                city: {
                    required: true
                },
                shoe_size: {
                    required: true
                }
            },
            messages: {
                fullname: 'Fullname required',
                instagram_username: 'Username required',
                email: 'Email required',
                address: 'Address required',
                zone: 'Zone required',
                postal_code: 'Postal code required',
                shoe_size: 'Shoe size required',
            },
            highlight: function(element) {

                if( $(element).parent().hasClass('puma-field-col')){
                    $(element).parents("div.puma-field-col").addClass('puma-field--has-error').removeClass('puma-field--is-valid');
                }else{
                    $(element).parents("div.puma-field-group").addClass('puma-field--has-error').removeClass('puma-field--is-valid');
                }
                
            },
            unhighlight: function(element) {
                if( $(element).parent().hasClass('puma-field-col')){
                    $(element).parents("div.puma-field-col").removeClass('puma-field--has-error').addClass('puma-field--is-valid');
                }else {
                    $(element).parents("div.puma-field-group").removeClass('puma-field--has-error').addClass('puma-field--is-valid');
                }
            },
            invalidHandler: function(){
                
                //$('.js-puma-lp-wrapper').removeAttr('style');
                //PUMALP.foldHeight();

            },
            errorPlacement: function(error, element) {
                var parent = $(element).parent();
                var placement = parent.hasClass('puma-field-group--checkbox-wrap');
                if (placement) {
                    parent.parent().append(error);
                } else {
                  error.insertAfter(element);
                }
            },
            submitHandler: function(form){
                PUMALP.subscribe($(form));
                //PUMALP.foldHeight();
                
            }
        });
    },
    subscribe: function($this){
        let action = $this.attr('action');
        let type = $this.attr('method');
        let redirect = $this.attr('data-redirect');
        let countryCode = $this.find('.puma-field-control--country-code').val();
        let mobileNumber = $this.find('.js-puma-field-control-mobile').val();

        var values = $this.serializeArray();
        values.push({
            name: "MERGE5",
            value: countryCode + mobileNumber
        });
        values = $.param(values);

        $.ajax({
            type: type,
            url: action,
            data: values,
            cache: false,
            dataType: 'jsonp',
            success: function (data) {
                console.log(data);
                if (data.result === 'success' ) {
                    //
                    $('.puma-field-group, .js-puma-lp-headline').addClass('puma-lp-hide');
                    $('.js-puma-lp-success').removeClass('puma-lp-hide');

                    setTimeout(function(){
                        window.location.href = redirect;
                    }, 5000);

                } else {
                    // Error Message

                    if( $('.puma-lg-error').length > 0 ){
                        $('.puma-lg-error').remove();
                    }

                    $('<div class="puma-lg-error">'+data.msg+'</div>').insertAfter('.puma-field-submit');

                    
                }
            }
        });

        
    },
    filterInput() {
        $('.js-puma-field-control-number').on('keydown', function() {
            console.log(isNaN($(this).val()));
            if (isNaN($(this).val())) {
                $(this).val($(this).val().replace(/\D/g, ''));
         
             } else {
                 //
             }
        });
        
    },
};

$(function(){
    PUMALP.init();
});
